import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmtr5mjmhj: FaireProductEntity = {
  token: "p_vmtr5mjmhj",
  type: "product",
  name: "Pilates Crop Tee and Biker Shorts Athleisure Set",
  brandToken: "b_axnmezu6gc",
  brandName: "Suhkasana",
  imageUrl:
    "https://cdn.faire.com/fastly/6611d5cabba539a2e196965cb2d4a1f7fb1628b59292fcf2435182f7708ba292.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4eca138a9f099820d5f0d67e08140c4880aad5b9397be46fb23d202a776a8ec8.jpeg",
    "https://cdn.faire.com/fastly/148016298d8d2aa17564268927ec85f7348e543931f2dd53171839417f421947.jpeg",
    "https://cdn.faire.com/fastly/214023ffe4bfcf1e121ba0157b25703d2bc501087ff5f12c4bff996105b6050e.jpeg",
    "https://cdn.faire.com/fastly/5d2d37b28d6fad089755a29a1b21e0c4657cacaeca235f91034e2381a33d535b.jpeg",
    "https://cdn.faire.com/fastly/13d3c229b79b670850727236518de326c42d77aec71f48916c46c215ca1eba2a.jpeg",
    "https://cdn.faire.com/fastly/0e83082eabbc48f5785aeba03f76abb01c1c53aa6077c92b638c1587c11c6f65.jpeg",
    "https://cdn.faire.com/fastly/3357ddceb900536a95cd5a114f3ccaa7d222fa384d9a0dd441f64178df909898.jpeg",
    "https://cdn.faire.com/fastly/d5cfae028b23aa7975f6b8d54186d4e558a1503abdfde6ee5fa5bb16b42b8aac.jpeg",
    "https://cdn.faire.com/fastly/583528207c8e95c9ef752dcfde7b157ca0376c5c0ca1ced113fd1302162e06f4.jpeg",
    "https://cdn.faire.com/fastly/62844270d34a4a324a600777b5fde2d4df545821b8c149eb68eab361783f0207.jpeg",
    "https://cdn.faire.com/fastly/1b3a1cf49e095eb8646f3309b7d999cfba7d2a7ab180e19b9003e5331b49de91.jpeg",
    "https://cdn.faire.com/fastly/e20d18fe4ff173812c9135ae303248af036ac47d0dd5f92aebe8211aca37bb3a.jpeg",
    "https://cdn.faire.com/fastly/6932f2b5e14ae7e86a6a0f82f74fbdb6ce03a48cc233e4555c4867c2e00ee41e.jpeg",
    "https://cdn.faire.com/fastly/1541546d71536f8c092fa622ff3a4c5a9824492cb5ac403e6041d7dac4cf31b9.png",
  ],
  priceDollars: 10.74,
  description:
    "• Pilates Inspired Athleisure Set: Designed with a clean, minimalist look that aligns with the trending Pilates aesthetic, perfect for modern boutique collections\n\n • Flattering Crop Tee Top: Fitted short sleeve crop top enhances natural curves while providing a sleek, active-ready silhouette\n\n • Stretch Fit Biker Shorts: High stretch biker shorts with an elastic drawstring waistband offer support, flexibility, and all-day comfort\n\n • Soft & Breathable Fabric: Lightweight and smooth fabric keeps you cool and comfortable, ideal for Pilates, yoga, and low-impact workouts\n\n • Versatile Everyday Wear: Perfect for Pilates sessions, gym workouts, lounging, travel, or casual outings. Easy to style with sneakers, hoodies, or oversized layers\n\n Brand labels are not included by default. If needed, please add them via this link ($0.50/pc): https://www.faire.com/product/p_mbyt838sy8 ",
  tags: [],
  msrpDollars: 21.48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:52.113Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
